import { render, staticRenderFns } from "./ProgrammesSmallCard.vue?vue&type=template&id=d01be812&"
import script from "./ProgrammesSmallCard.vue?vue&type=script&lang=js&"
export * from "./ProgrammesSmallCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports